import React from 'react';
import { Box } from '@mui/material';
import BasicButton from '../../../components/button/BasicButton';

const ProfilePageActions = ({
  variant = 'desktop', // 'desktop', 'tablet', 'mobile'
  isMyPage,
  isAdminView,
  handleProfileSettingClick,
  handleMemberSettingClick,
  handleEditClick,
  handleProfileShare,
}) => {
  const buttonStyles = {
    desktop: { width: '130px', height: '40px', padding: '16px 12px' },
    tablet: { height: '40px', padding: '16px 17px', whiteSpace: 'nowrap' },
    mobile: { width: '100%', height: '40px', padding: '16px 24px' },
  };

  const actionButtonSx = {
    typography: 'body3',
    fontWeight: 'medium',
  };

  const containerStyles = {
    desktop: { display: 'flex', flexDirection: 'column', gap: 1 },
    tablet: { display: 'flex', gap: 1 },
    mobile: { display: 'flex', gap: 1, width: '100%' },
  };

  return (
    <Box sx={containerStyles[variant]}>
      {isMyPage && (
        <>
          <BasicButton
            variant="outlined"
            onClick={handleProfileSettingClick}
            sx={{ ...buttonStyles[variant], ...actionButtonSx }}
          >
            프로필 설정
          </BasicButton>
          <BasicButton
            variant="outlined"
            onClick={handleProfileShare}
            sx={{ ...buttonStyles[variant], ...actionButtonSx }}
          >
            프로필 공유
          </BasicButton>
        </>
      )}
      {isAdminView && (
        <>
          <BasicButton
            variant="outlined"
            onClick={handleEditClick}
            sx={{ ...buttonStyles[variant], ...actionButtonSx }}
          >
            정보 수정
          </BasicButton>
          <BasicButton
            variant="outlined"
            onClick={handleMemberSettingClick}
            sx={{ ...buttonStyles[variant], ...actionButtonSx }}
          >
            회원 설정
          </BasicButton>
        </>
      )}
    </Box>
  );
};

export default ProfilePageActions;
